import app from './app';
import { getEnvValue, getExternalAssetFilePath } from './utils';

const defaultImageUrl = '/images/pkrd_og_image.svg';

const meta = Object.freeze({
  promoteBlockscoutInTitle: false, // Don't promote Blockscout for PKRD
  og: {
    description: getEnvValue('NEXT_PUBLIC_OG_DESCRIPTION') || 'PKRD Blockchain Explorer - Advanced blockchain analytics and exploration tools for the PKRD ecosystem.',
    imageUrl: app.baseUrl + (getExternalAssetFilePath('NEXT_PUBLIC_OG_IMAGE_URL') || defaultImageUrl),
    enhancedDataEnabled: getEnvValue('NEXT_PUBLIC_OG_ENHANCED_DATA_ENABLED') === 'true',
  },
  seo: {
    enhancedDataEnabled: getEnvValue('NEXT_PUBLIC_SEO_ENHANCED_DATA_ENABLED') === 'true',
  },
  // PKRD specific meta tags
  pkrd: {
    title: 'PKRD Blockchain Explorer',
    description: 'Explore the PKRD blockchain with advanced analytics and exploration tools.',
    keywords: 'PKRD, blockchain, explorer, cryptocurrency, transactions, blocks, smart contracts',
    author: 'PKRD Blockchain',
    themeColor: '#000000',
  },
});

export default meta;
